export default function speech(message: string, rate : number) {
    const msg = new SpeechSynthesisUtterance()
    msg.text = message.split('|')[0]
    msg.rate = rate
    msg.lang = "fr-fr"
    window.speechSynthesis.speak(msg)

    setTimeout(() => {

    }, 1000);

    msg.text = message.split('|')[1]
    msg.rate = rate
    msg.lang = "en-EN"
    window.speechSynthesis.speak(msg)
}